import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';

/** Thin wrapper over window.location so full-page navigation can be replaced in tests. */
@Injectable({ providedIn: 'root' })
export class BrowserNavigator {
    private readonly window = inject(DOCUMENT).defaultView;

    /** Navigates without leaving the current page in history (Back cannot return to it). */
    replace(url: string): void {
        this.window?.location.replace(url);
    }

    reload(): void {
        this.window?.location.reload();
    }
}
